let authPersistenceStatus = {
  mode: "unknown",
  isLimitedPersistence: false,
  error: "",
};

function toErrorMessage(error) {
  return error?.message || error?.code || String(error || "");
}

export async function configureAuthPersistence({
  auth,
  setPersistence,
  localPersistence,
  sessionPersistence,
  memoryPersistence,
}) {
  const attempts = [
    { mode: "local", persistence: localPersistence },
    { mode: "session", persistence: sessionPersistence },
    { mode: "memory", persistence: memoryPersistence },
  ].filter((attempt) => attempt.persistence);

  let lastError = null;
  for (const attempt of attempts) {
    try {
      await setPersistence(auth, attempt.persistence);
      authPersistenceStatus = {
        mode: attempt.mode,
        isLimitedPersistence: attempt.mode !== "local",
        error: lastError ? toErrorMessage(lastError) : "",
      };
      return authPersistenceStatus;
    } catch (error) {
      lastError = error;
    }
  }

  authPersistenceStatus = {
    mode: "failed",
    isLimitedPersistence: true,
    error: toErrorMessage(lastError),
  };
  return authPersistenceStatus;
}

export function getAuthPersistenceStatus() {
  return authPersistenceStatus;
}

export function resetAuthPersistenceStatusForTests() {
  authPersistenceStatus = {
    mode: "unknown",
    isLimitedPersistence: false,
    error: "",
  };
}
